/* MB Favoloso Shop — Effetti premium globali */
(function () {
  var doc = document.documentElement;
  if (doc.dataset.mbFavolosoPremium === 'true') return;
  doc.dataset.mbFavolosoPremium = 'true';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isEditor = window.Shopify && window.Shopify.designMode;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal() {
    var selectors = [
      '.shopify-section',
      '.card-wrapper',
      '.product-card-wrapper',
      '.collection-card',
      '.article-card',
      '.blog-card',
      '.media-card',
      '.product__media',
      '.collapsible-content__item',
      '.accordion',
      '.rich-text',
      '.image-with-text',
      '.newsletter',
      '.footer-block'
    ].join(',');

    var items = Array.prototype.slice.call(document.querySelectorAll(selectors))
      .filter(function (el) {
        if (el.classList.contains('mbfx-reveal') || el.closest('[hidden]')) return false;
        if (el.matches('lion-cart-drawer, .cart-drawer, .drawer, .modal, .quick-add-modal, .predictive-search, .menu-drawer')) return false;
        if (el.querySelector && el.querySelector('lion-cart-drawer, .cart-drawer, .drawer, .modal, .quick-add-modal, .predictive-search, .menu-drawer')) return false;
        if (el.closest && el.closest('header, .header, .header-wrapper, footer, .footer, lion-cart-drawer, .cart-drawer, .drawer, .modal, .quick-add-modal, .predictive-search, .menu-drawer')) return false;
        return true;
      });

    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el, index) {
      el.classList.add('mbfx-reveal');
      el.style.transitionDelay = Math.min(index % 8, 6) * 45 + 'ms';
      observer.observe(el);
    });
  }

  function initPointerGlow() {
    if (reduceMotion || isEditor || window.innerWidth < 990) return;

    var glow = document.createElement('div');
    glow.className = 'mbfx-pointer-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);

    var x = 0, y = 0, tx = 0, ty = 0, raf = null;

    function render() {
      x += (tx - x) * 0.18;
      y += (ty - y) * 0.18;
      glow.style.left = x + 'px';
      glow.style.top = y + 'px';
      raf = requestAnimationFrame(render);
    }

    document.addEventListener('pointermove', function (event) {
      tx = event.clientX;
      ty = event.clientY;
      document.body.classList.add('mbfx-has-pointer');
      if (!raf) render();
    }, { passive: true });

    document.addEventListener('pointerleave', function () {
      document.body.classList.remove('mbfx-has-pointer');
    });
  }

  function initSectionSpotlight() {
    if (reduceMotion || window.innerWidth < 990) return;

    document.addEventListener('pointermove', function (event) {
      var section = event.target.closest && event.target.closest('.shopify-section');
      if (!section) return;
      var rect = section.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      section.style.setProperty('--mbfx-x', x.toFixed(1) + '%');
      section.style.setProperty('--mbfx-y', y.toFixed(1) + '%');
    }, { passive: true });
  }

  function addTitleLines() {
    var headings = document.querySelectorAll('.shopify-section h1, .shopify-section h2, .shopify-section .h1, .shopify-section .h2');
    headings.forEach(function (heading) {
      if (heading.classList.contains('mbfx-title-line')) return;
      if (heading.closest('.header, header, .footer, footer, .product-card-wrapper, .card-wrapper')) return;
      heading.classList.add('mbfx-title-line');
    });
  }

  function init() {
    initReveal();
    initPointerGlow();
    initSectionSpotlight();
    addTitleLines();
  }

  ready(init);

  document.addEventListener('shopify:section:load', function () {
    doc.dataset.mbFavolosoPremium = 'true';
    initReveal();
    addTitleLines();
  });
})();
